module.exports = __webpack_public_path__ + "static/battle04-4719615e44011aeea0c89de17c2e7d8d.png";